const MUTE_KEY = 'notifications.muted'
const SOUND_URL = '/bell.wav'

let cachedAudio: HTMLAudioElement | null = null

function getAudio(): HTMLAudioElement {
  if (!cachedAudio) {
    cachedAudio = new Audio(SOUND_URL)
    cachedAudio.preload = 'auto'
    cachedAudio.volume = 0.6
  }
  return cachedAudio
}

export const notificationSound = {
  isMuted(): boolean {
    return localStorage.getItem(MUTE_KEY) === '1'
  },
  setMuted(muted: boolean): void {
    if (muted) localStorage.setItem(MUTE_KEY, '1')
    else localStorage.removeItem(MUTE_KEY)
  },
  play(): void {
    if (this.isMuted()) return
    try {
      const audio = getAudio()
      audio.currentTime = 0
      void audio.play().catch(() => {
        // Autoplay blocked until first user gesture — silently ignore
      })
    } catch {
      // ignore
    }
  },
}
